define(['jquery'], function ($) {

    var ERVFlexMenu = function () {
        var self = this;
        self.$ervBody = $('#erv-body');
        var breaks = [];

        self.getOrCreateHiddenLinks = function ($container) {
            var $hlinks = $container.find('.hidden-links');
            if ($hlinks.length === 0) {
                $hlinks = $('<ul>').addClass('hidden-links');
                $container.append($hlinks);
            }
            return $hlinks;
        };

        self.updateNav = function () {
            if (!self.$nav || !self.$trigger) {
                console.error("ERVFlexMenu not properly initialized. $nav or $trigger missing.");
                return;
            }

            var $vlinks = self.$nav.find('.visible-links');
            var $flexMenuContainer = self.$trigger.parent();

            if ($vlinks.length === 0 || $flexMenuContainer.length === 0) {
                return;
            }

            var availableSpace = self.$nav.width() - self.$trigger.find('span').width() - 40;
            var $hlinks = $flexMenuContainer.find('.hidden-links');

            if ($vlinks.width() > availableSpace) {
                if ($vlinks.children().length > 1) {
                    breaks.push($vlinks.width());
                    $hlinks = self.getOrCreateHiddenLinks($flexMenuContainer);
                    $vlinks.children().last().prependTo($hlinks);
                    $hlinks = $flexMenuContainer.find('.hidden-links');
                }
            }
            else if ($hlinks.length > 0 && $hlinks.children().length > 0 && availableSpace > breaks[breaks.length - 1]) {
                 $hlinks.children().first().appendTo($vlinks);
                 breaks.pop();

                 if ($hlinks.children().length === 0) {
                     $hlinks.remove();
                     $hlinks = $();
                 }
            }

            $hlinks = $flexMenuContainer.find('.hidden-links');
            var hiddenCount = $hlinks.length > 0 ? $hlinks.children().length : 0;

            self.$trigger.attr('data-count', hiddenCount);

            if (hiddenCount > 0) {
                $flexMenuContainer.removeClass('invisible');
            } else {
                $flexMenuContainer.addClass('invisible');
                if ($hlinks.length > 0) {
                     $hlinks.remove();
                }
            }

            if ($vlinks.width() > availableSpace && $vlinks.children().length > 1) {
                 self.updateNav();
            }
        };
    };

    ERVFlexMenu.prototype.init = function (selector) {
        var self = this, $window = $(window), width = $window.width(), resizeId;
        self.$nav = self.$ervBody.find(selector);
        self.$trigger = self.$nav.find('.flex-menu .menu-title');

        if (self.$nav.length === 0) {
            console.error("ERVFlexMenu init failed: Main navigation container (" + selector + ") not found within #erv-body.");
            return;
        }
        if (self.$trigger.length === 0) {
            console.error("ERVFlexMenu init failed: Trigger element (.flex-menu .menu-title) not found within " + selector + ".");
        }

        self.updateNav();

        $window.resize(function () {
            var newWidth = $(window).width();
            if (width !== newWidth) {
                width = newWidth;
                clearTimeout(resizeId);
                breaks = [];
                resizeId = setTimeout(function () {
                    self.updateNav();
                }, 100);
            }
        });

        if (self.$trigger.length > 0) {
             self.$trigger.on('click', function (e) {
                 $(this).closest('.flex-menu').toggleClass('is-expanded');
                 e.stopPropagation();
             });

             $(document).on('click', function (e) {
                var $flexMenuContainer = self.$trigger.closest('.flex-menu');
                if ($flexMenuContainer.hasClass('is-expanded') && !$flexMenuContainer.is(e.target) && $flexMenuContainer.has(e.target).length === 0) {
                    $flexMenuContainer.removeClass('is-expanded');
                }
             });
        }
    };

    return ERVFlexMenu;
});